export default function (value) {
    // Exclude quotes and angle brackets from the URL token so a crafted "URL" (e.g.
    // http://x"onmouseover=…) can't break out of the href attribute or inject markup — this is
    // rendered via v-html, so the matched token must stay attribute/markup-safe.
    return value?.replaceAll(/(https?[^\s"'<>]+)/gi, '<a href="$1" target="_blank">$1</a>');
}
